import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import type { RoleItem } from '../../../common/types';
import { multipleRolesMessage } from '../../../common/utils';
import { filterByRolesText } from './messages';

export const getRolesDropdownLabel = (roleItems: RoleItem[], intl: IntlShape) => {
	const selectedRoles = roleItems.filter((o) => o.isChecked);
	switch (selectedRoles.length) {
		case 0:
			return intl.formatMessage(filterByRolesText.clickToFilterByRoles);
		case 1:
			return selectedRoles[0].translatedName;
		default:
			return multipleRolesMessage(intl, selectedRoles.length);
	}
};
